/**
 * Flag para ativar adaptações de comportamento apenas durante desenvolvimento.
 * Controlada pela variável de ambiente REACT_APP_DEV_ADAPTATION.
 *
 * Uso:
 *   import { isDevAdaptationEnabled } from 'Utils/devAdaptation';
 *
 *   if (isDevAdaptationEnabled) {
 *     // lógica especial de desenvolvimento
 *   }
 *
 * Configure em .env.stg (dev local):
 *   REACT_APP_DEV_ADAPTATION=true
 *
 * Em produção (.env) mantenha:
 *   REACT_APP_DEV_ADAPTATION=false
 */
const isDevAdaptationEnabled = process.env.REACT_APP_DEV_ADAPTATION === 'true';

export { isDevAdaptationEnabled };
export default isDevAdaptationEnabled;
